import { FileSelectorModal, SelectorImage } from "./FileSelectorModal";

interface FileSelectorEditorOtherParams {
  getImages?: (project: any) => SelectorImage[];
  getSelectedImages?: () => (string | number)[];
  onConfirm?: (images: SelectorImage[]) => void;
  onRemove?: (id: string | number) => void;
  buttonLabel?: string;
  title?: string;
  description?: string;
  [key: string]: unknown;
}

interface FileSelectorEditorRecord {
  otherParams?: FileSelectorEditorOtherParams | null;
  [key: string]: unknown;
}

interface FileSelectorEditorProps {
  record?: FileSelectorEditorRecord | null;
  onClose: () => void;
  editorInstance?: unknown;
}

export const FileSelectorEditor = ({ record, onClose }: FileSelectorEditorProps) => {
  const params = record?.otherParams;

  if (!params?.getImages) return null;

  return (
    <FileSelectorModal
      getImages={params.getImages}
      getSelectedImages={params.getSelectedImages}
      onConfirm={params.onConfirm}
      onRemove={params.onRemove}
      buttonLabel={params.buttonLabel}
      title={params.title}
      description={params.description}
      onClose={onClose}
    />
  );
};
